import classNames from "classnames";
import useIsMobile from "../../common/utils/useIsMobile";
import { Link, usePathname } from "../../../navigation";
import Image from "next/image";
import { useLayoutEffect } from "react";
import Icon from "../../common/components/Icon";
import CartSwitch from "../../portal/components/cart/CartSwitch";
import AvatarButton from "./AvatarButton";

const MainNavigation = ({
  navigationData,
  onTopLevelClick,
  selectedLayout,
  SearchInputComponent,
}) => {
  const isMobile = useIsMobile();
  const pathname = usePathname();

  useLayoutEffect(() => {
    const stickyItems = document.querySelectorAll(".sticky-nav-item");

    const onScroll = () => {
      if (!stickyItems?.length) return;
      const shouldShow = window.scrollY > 62;
      stickyItems.forEach((el) => {
        el.classList.toggle("is-sticky", shouldShow);
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const LinkComponent = isMobile ? "button" : Link;

  let linkProps: any = {};

  return (
    <nav
      className={classNames(
        `d-flex justify-content-between align-items-center gap-3`,
        {
          "hide-on-mobile": selectedLayout,
        },
      )}
    >
      <div className="d-flex flex-column flex-lg-row gap-lg-5 flex-grow-1">
        <Link href="/" className="sticky-nav-item">
          <Image
            src="/portal/img/publicare-logomark.png"
            alt="Logo"
            width={42}
            height={42}
          />
        </Link>
        {navigationData.map((rootItem) => {
          const normalizedUrl =
            typeof rootItem?.url === "string"
              ? rootItem?.url
              : rootItem?.url?.route;
          if (isMobile)
            linkProps = {
              onClick: () => onTopLevelClick(rootItem),
            };
          else {
            linkProps = {
              href:
                typeof rootItem?.url === "string"
                  ? rootItem?.url
                  : rootItem?.url?.route,
              onMouseEnter: () => onTopLevelClick(rootItem),
              onClick: (e) => {
                // Prevent navigation and handle as menu toggle on touch devices
                if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
                  e.preventDefault();
                  onTopLevelClick(rootItem);
                }
              },
            };
          }
          return (
            <LinkComponent
              key={rootItem?.title}
              className={`mkt-nav-button ${
                pathname.startsWith(normalizedUrl) ||
                rootItem?.meta?.layout === selectedLayout ||
                (selectedLayout === "services" && !rootItem?.meta?.layout)
                  ? "active"
                  : ""
              }`}
              aria-label={`Navigate to ${rootItem.title}`}
              {...linkProps}
            >
              {rootItem.title}
            </LinkComponent>
          );
        })}
      </div>

      <div className="hide-on-mobile d-flex align-items-center gap-3">
        <AvatarButton className="sticky-nav-item sticky-nav-item--avatar" />
        {SearchInputComponent}

        <CartSwitch />
      </div>
    </nav>
  );
};

export default MainNavigation;
